import React, {Component} from 'react';
import { Link } from 'react-router-dom'

class Apply extends Component {
    constructor(props) {
        super(props);
        this.state = {
            percs: {
                x1: 0.662,
                x2: 0.820,
                y1: 0.893,
                y2: 0.940
            },
            coords: "0,0,0,0"
        };
    }

    getCoordinates = () => {
        let img = window.document.getElementById("applyBG");
        let imgWidth = img.width;
        let imgHeight = img.height;
        
        const x1 = imgWidth  * this.state.percs.x1;
        const x2 = imgWidth  * this.state.percs.x2;
        const y1 = imgHeight * this.state.percs.y1;
        const y2 = imgHeight * this.state.percs.y2;
    
        let coords = x1 + "," + y1 + "," + x2 + "," + y2;
        this.setState({coords: coords});
    }

    componentDidMount() {
        window.addEventListener('load', this.getCoordinates);
        window.addEventListener('resize', this.getCoordinates);
        let img = window.document.getElementById("applyBG");
        if (img.width === 0) {
            setTimeout(this.getCoordinates, 1000);
        }
        this.getCoordinates();
    }

    render() {
        return (
            <div className="App">
                <img id="applyBG" src="2_military.jpg" alt="Military Demo" useMap="#backButton" />
                <a href="https://offers.sheerid.com/demo-bank-military/">
                    <map name="backButton">
                        <area shape="rect" coords={this.state.coords} alt="APPLY NOW" />
                    </map>
                </a>
            </div>
        );
    }
}

export default Apply;
    